import {createSlice} from '@reduxjs/toolkit'
import { fetchprovince } from '../../action/master/provinceAction'

interface provinceState {
  data: any
  status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error: string | null
}

const initialState: provinceState = {
  data: null,
  status: 'idle',
  error: null,
}

const provinceSlice = createSlice({
  name: 'province',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchprovince.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(fetchprovince.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload
        
      })
      .addCase(fetchprovince.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message || 'Failed to fetch province data'
      })
  },
})

export default provinceSlice.reducer